import React, {Component} from "react";
import {PageHeader, ListGroup, ListGroupItem, Button} from "react-bootstrap";
import {LinkContainer} from "react-router-bootstrap";
//import "./Home.css";
import "./HomeAlt.css";
import "./c3jscustom.css";
import {API} from "aws-amplify";
import {Page, Icon, Grid, Card, Table, colors, StatsCard} from "tabler-react";

import C3Chart from "react-c3js";

export default class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            demoUser: false,
            bodysigns: []
        };
    }

    async componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            const bodysigns = await this.bodysigns();
            this.setState({bodysigns});
        } catch (e) {
            alert(e);
        }

        try {
            let demoUser = await this.demoCheck();
            this.setState({demoUser});
        } catch (e) {
            alert(e);
        }

        this.setState({isLoading: false});
    }

    bodysigns() {
        return API.get("bodysigns", "/notebook");
    }

    demoCheck() {
        var dUser = false;
        for (var key in this.state.bodysigns) {
            if (this.state.bodysigns.hasOwnProperty(key) && this.state.bodysigns[key].userId === "us-west-2:65fd7f41-9610-41dc-a92d-11d400d107ca") {
                dUser = true;
                break;
            }
        }
        return dUser;
    }

    renderBodysignsList(bodysigns) {
        console.log(this.state.demoUser);
        if (!!this.state.demoUser) {
            console.log("i am rendering dashboard level 2");
            return (
                <Page.Content title="Your Body Overview">
                    <Grid.Row>
                        <Grid.Col md={6} lg={12}>
                            <Grid.Row>
                                <Grid.Col sm={6} lg={3}>
                                    <StatsCard
                                        layout={2}
                                        movement={5}
                                        total="8"
                                        label="Back Pain"
                                        chart={
                                            <C3Chart
                                                style={{height: "100%"}}
                                                padding={{
                                                    bottom: -10,
                                                    left: -1,
                                                    right: -1,
                                                }}
                                                data={{
                                                    names: {
                                                        data1: "Pain Index",
                                                    },
                                                    columns: [["data1", 30, 40, 10, 40, 12, 22, 40]],
                                                    type: "area",
                                                }}
                                                legend={{
                                                    show: false,
                                                }}
                                                transition={{
                                                    duration: 0,
                                                }}
                                                point={{
                                                    show: false,
                                                }}
                                                tooltip={{
                                                    format: {
                                                        title: function (x) {
                                                            return "";
                                                        },
                                                    },
                                                }}
                                                axis={{
                                                    y: {
                                                        padding: {
                                                            bottom: 0,
                                                        },
                                                        show: false,
                                                        tick: {
                                                            outer: false,
                                                        },
                                                    },
                                                    x: {
                                                        padding: {
                                                            left: 0,
                                                            right: 0,
                                                        },
                                                        show: false,
                                                    },
                                                }}
                                                color={{
                                                    pattern: ["#467fcf"],
                                                }}
                                            />
                                        }
                                    />
                                </Grid.Col>
                                <Grid.Col sm={6} lg={3}>
                                    <StatsCard
                                        layout={2}
                                        movement={-3}
                                        total="Stable"
                                        label="Diarrhea"
                                        chart={
                                            <C3Chart
                                                style={{height: "100%"}}
                                                padding={{
                                                    bottom: -10,
                                                    left: -1,
                                                    right: -1,
                                                }}
                                                data={{
                                                    names: {
                                                        data1: "Diarrhea",
                                                    },
                                                    columns: [["data1", 30, 40, 10, 40, 12, 22, 40]],
                                                    type: "area",
                                                }}
                                                legend={{
                                                    show: false,
                                                }}
                                                transition={{
                                                    duration: 0,
                                                }}
                                                point={{
                                                    show: false,
                                                }}
                                                tooltip={{
                                                    format: {
                                                        title: function (x) {
                                                            return "";
                                                        },
                                                    },
                                                }}
                                                axis={{
                                                    y: {
                                                        padding: {
                                                            bottom: 0,
                                                        },
                                                        show: false,
                                                        tick: {
                                                            outer: false,
                                                        },
                                                    },
                                                    x: {
                                                        padding: {
                                                            left: 0,
                                                            right: 0,
                                                        },
                                                        show: false,
                                                    },
                                                }}
                                                color={{
                                                    pattern: ["#e74c3c"],
                                                }}
                                            />
                                        }
                                    />
                                </Grid.Col>
                                <Grid.Col sm={6} lg={3}>
                                    <StatsCard
                                        layout={2}
                                        movement={-3}
                                        total="Normal"
                                        label="Appetite"
                                        chart={
                                            <C3Chart
                                                style={{height: "100%"}}
                                                padding={{
                                                    bottom: -10,
                                                    left: -1,
                                                    right: -1,
                                                }}
                                                data={{
                                                    names: {
                                                        data1: "Appetite",
                                                    },
                                                    columns: [["data1", 30, 40, 10, 40, 12, 22, 40]],
                                                    type: "area",
                                                }}
                                                legend={{
                                                    show: false,
                                                }}
                                                transition={{
                                                    duration: 0,
                                                }}
                                                point={{
                                                    show: false,
                                                }}
                                                tooltip={{
                                                    format: {
                                                        title: function (x) {
                                                            return "";
                                                        },
                                                    },
                                                }}
                                                axis={{
                                                    y: {
                                                        padding: {
                                                            bottom: 0,
                                                        },
                                                        show: false,
                                                        tick: {
                                                            outer: false,
                                                        },
                                                    },
                                                    x: {
                                                        padding: {
                                                            left: 0,
                                                            right: 0,
                                                        },
                                                        show: false,
                                                    },
                                                }}
                                                color={{
                                                    pattern: ["#5eba00"],
                                                }}
                                            />
                                        }
                                    />
                                </Grid.Col>
                                <Grid.Col sm={6} lg={3}>
                                    <StatsCard
                                        layout={2}
                                        movement={9}
                                        total="7"
                                        label="Fatigue"
                                        chart={
                                            <C3Chart
                                                style={{height: "100%"}}
                                                padding={{
                                                    bottom: -10,
                                                    left: -1,
                                                    right: -1,
                                                }}
                                                data={{
                                                    names: {
                                                        data1: "Fatigue",
                                                    },
                                                    columns: [["data1", 30, 40, 10, 40, 12, 22, 40]],
                                                    type: "area",
                                                }}
                                                legend={{
                                                    show: false,
                                                }}
                                                transition={{
                                                    duration: 0,
                                                }}
                                                point={{
                                                    show: false,
                                                }}
                                                tooltip={{
                                                    format: {
                                                        title: function (x) {
                                                            return "";
                                                        },
                                                    },
                                                }}
                                                axis={{
                                                    y: {
                                                        padding: {
                                                            bottom: 0,
                                                        },
                                                        show: false,
                                                        tick: {
                                                            outer: false,
                                                        },
                                                    },
                                                    x: {
                                                        padding: {
                                                            left: 0,
                                                            right: 0,
                                                        },
                                                        show: false,
                                                    },
                                                }}
                                                color={{
                                                    pattern: ["#f1c40f"],
                                                }}
                                            />
                                        }
                                    />
                                </Grid.Col>
                            </Grid.Row>
                        </Grid.Col>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Col md={6} lg={12}>
                            <Card>
                                <Card.Header>
                                    <Card.Title>Overall Health</Card.Title>
                                </Card.Header>
                                <C3Chart
                                    style={{height: "10rem"}}
                                    data={{
                                        columns: [
                                            // each columns data
                                            [
                                                "data1",
                                                10,
                                                15,
                                                11,
                                                12,
                                                17,
                                                15,
                                                16,
                                                18,
                                                36,
                                                17,
                                                22,
                                                15,
                                                16,
                                                13,
                                                12,
                                                12,
                                                16,
                                                50,
                                                30,
                                                20,
                                                25,
                                                24,
                                                57,
                                                75,
                                                72,
                                            ],
                                        ],
                                        type: "area", // default type of chart
                                        groups: [["data1", "data2", "data3"]],
                                        colors: {
                                            data1: colors["blue"],
                                        },
                                        names: {
                                            // name of each serie
                                            data1: "Body Index (1-100)",
                                        },
                                    }}
                                    axis={{
                                        y: {
                                            padding: {
                                                bottom: 0,
                                            },
                                            show: false,
                                            tick: {
                                                outer: false,
                                            },
                                        },
                                        x: {
                                            padding: {
                                                left: 0,
                                                right: 0,
                                            },
                                            show: true,
                                        },
                                    }}
                                    legend={{
                                        position: "inset",
                                        padding: 0,
                                        inset: {
                                            anchor: "top-left",
                                            x: 20,
                                            y: 8,
                                            step: 10,
                                        },
                                    }}
                                    tooltip={{
                                        format: {
                                            title: function (x) {
                                                return "";
                                            },
                                        },
                                    }}
                                    padding={{
                                        bottom: 0,
                                        left: -1,
                                        right: -1,
                                    }}
                                    point={{
                                        show: false,
                                    }}
                                />
                                <Table
                                    cards={true}
                                    striped={true}
                                    responsive={true}
                                    className="table-vcenter"
                                >
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.ColHeader colSpan={2}>Reading</Table.ColHeader>
                                            <Table.ColHeader>Description</Table.ColHeader>
                                            <Table.ColHeader>Last observed</Table.ColHeader>
                                            <Table.ColHeader/>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        <Table.Row>
                                            <Table.Col className="w-1">
                                                <Icon prefix="fe" name="cloud-drizzle"/>
                                            </Table.Col>
                                            <Table.Col>Bleeding</Table.Col>
                                            <Table.Col>Gum, sustained, 2 hours</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 11, 2018</Table.Col>
                                            <Table.Col className="w-1">
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="alert-triangle"/>
                                            </Table.Col>
                                            <Table.Col>Bruise</Table.Col>
                                            <Table.Col>Knee, True/False, fell off the chair</Table.Col>
                                            <Table.Col className="text-nowrap">
                                                Dec 13, 2018
                                            </Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="fast-forward"/>
                                            </Table.Col>
                                            <Table.Col>Exercise</Table.Col>
                                            <Table.Col>35 minutes of walking, strenuous levels</Table.Col>
                                            <Table.Col className="text-nowrap">
                                                Dec 9, 2018
                                            </Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="git-merge"/>
                                            </Table.Col>
                                            <Table.Col>Exercise</Table.Col>
                                            <Table.Col>Yoga, 30 minutes, Iyengar yoga, 10 minutes of cool
                                                down</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 12, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="eye"/>
                                            </Table.Col>
                                            <Table.Col>Eyes</Table.Col>
                                            <Table.Col>Watery, off/on for whole day, redness developed</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 12, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="bar-chart-2"/>
                                            </Table.Col>
                                            <Table.Col>Fingers</Table.Col>
                                            <Table.Col>Numbness developed in the index finger of the right
                                                hand</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 9, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="layers"/>
                                            </Table.Col>
                                            <Table.Col>Food</Table.Col>
                                            <Table.Col>3 slices of bread for breakfast</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 21, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="grid"/>
                                            </Table.Col>
                                            <Table.Col>Food</Table.Col>
                                            <Table.Col>Rice with lentil soup for lunch</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 16, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="filter"/>
                                            </Table.Col>
                                            <Table.Col>Food</Table.Col>
                                            <Table.Col>5 glasses of water throughout the day</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 17, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="activity"/>
                                            </Table.Col>
                                            <Table.Col>Heart</Table.Col>
                                            <Table.Col>121 over 89, with normal exercise levels</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 9, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="thumbs-down"/>
                                            </Table.Col>
                                            <Table.Col>Medicine</Table.Col>
                                            <Table.Col>Nausea suppressing medicine, 2 pills taken 3 times a day</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 9, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="thumbs-down"/>
                                            </Table.Col>
                                            <Table.Col>Mouth</Table.Col>
                                            <Table.Col>Sore throat developed in the evening</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 10, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="thumbs-down"/>
                                            </Table.Col>
                                            <Table.Col>Nose</Table.Col>
                                            <Table.Col>Stuffy throughout the day, some relief in the night</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 12, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="alert-circle"/>
                                            </Table.Col>
                                            <Table.Col>Pain</Table.Col>
                                            <Table.Col>Pain developed in the back of the neck during the day</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 20, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="target"/>
                                            </Table.Col>
                                            <Table.Col>Rash</Table.Col>
                                            <Table.Col>Constant and increasing itching near the port mount</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 21, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="thumbs-up"/>
                                            </Table.Col>
                                            <Table.Col>Sleep</Table.Col>
                                            <Table.Col>Slept well, possible 3+ hours of REM</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 9, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="thumbs-down"/>
                                            </Table.Col>
                                            <Table.Col>Stomach</Table.Col>
                                            <Table.Col>Appetite is not consistent for last four days</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 7, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="sunrise"/>
                                            </Table.Col>
                                            <Table.Col>Stool</Table.Col>
                                            <Table.Col>Felt constipated throughout the day</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 10, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="loader"/>
                                            </Table.Col>
                                            <Table.Col>Swelling</Table.Col>
                                            <Table.Col>Feet swell up in the morning for last 2 days</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 18, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="thermometer"/>
                                            </Table.Col>
                                            <Table.Col>Temperature</Table.Col>
                                            <Table.Col>96.6 at 10am</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 19, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="anchor"/>
                                            </Table.Col>
                                            <Table.Col>Weight</Table.Col>
                                            <Table.Col>133 Lbs, taken right after breakfast</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 24, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                    </Table.Body>
                                </Table>
                            </Card>
                        </Grid.Col>
                    </Grid.Row>
                </Page.Content>
            );
            /*
                        return [{}].concat(bodysigns).map(
                            (bodysign, i) =>
                                i !== 0
                                    ? <LinkContainer key={bodysign.noteId} to={`/notebook/${bodysign.noteId}`}>
                                        <ListGroupItem header={bodysign.content.trim().split("\n")[0]}>
                                            {"Created: " + new Date(bodysign.createdAt).toLocaleString()}
                                        </ListGroupItem>
                                    </LinkContainer>
                                    : <LinkContainer key="new" to="/notebook/new">
                                        <ListGroupItem>
                                            <h4>
                                                <b>{"\uFF0B"}</b> Create a new entry in the notebook
                                            </h4>
                                        </ListGroupItem>
                                    </LinkContainer>
                        );

            */
        } else {
            console.log("i am rendering bodysigns level 2");

            return [{}].concat(bodysigns).map(
                (bodysign, i) =>
                    i !== 0
                        ? <LinkContainer key={bodysign.noteId} to={`/notebook/${bodysign.noteId}`}>
                            <ListGroupItem header={bodysign.content.trim().split("\n")[0]}>
                                {"Created: " + new Date(bodysign.createdAt).toLocaleString()}
                            </ListGroupItem>
                        </LinkContainer>
                        : <LinkContainer key="new" to="/notebook/new">
                            <ListGroupItem>
                                <h4>
                                    <b>{"\uFF0B"}</b> Create a new entry in the notebook
                                </h4>
                            </ListGroupItem>
                        </LinkContainer>
            );
        }
    }

    renderLander() {
        return (
            <div className="lander">
                <Grid.Row>
                    <h1>Project Notebook</h1>
                    <p>Your vital signs. You collect it. You own it. You use it.</p>
                </Grid.Row>
                <Grid.Row className="show-grid">
                    <Grid.Col md={6} mdPull={6} className="left">
                        <p>Maintaining your own data or</p>
                        <p>caring for someone who is?</p>
                        <p> &nbsp; </p>
                        <Button href="/signup">Create Patient Account</Button>
                    </Grid.Col>
                    <Grid.Col md={6} mdPush={6} className="right">
                        <p>Doctor, healthcare provider or </p>
                        <p>clinic looking to help patients?</p>
                        <p> &nbsp; </p>
                        <Button href="/signupDoc">Create Physician Account</Button>
                    </Grid.Col>
                </Grid.Row>
            </div>
        );
    }

    renderBodysigns() {
        console.log(this.state.demoUser);
        if (!!this.state.demoUser) {
            console.log("i am rendering dashboard level 1");
            return (
                <ListGroup>
                    {!this.state.isLoading && this.renderBodysignsList(this.state.bodysigns)}
                </ListGroup>
            );
        } else {
            console.log("i am rendering bodysigns level 1");
            return (
                <div className="bodysigns">
                    <p>&nbsp;</p>
                    <PageHeader>Your vital signs - recorded so far</PageHeader>
                    <ListGroup>
                        {!this.state.isLoading && this.renderBodysignsList(this.state.bodysigns)}
                    </ListGroup>
                </div>
            );
        }
    }

    renderBodysignsList2(bodysigns) {
        console.log(this.state.demoUser);
        if (!!this.state.demoUser) {
            console.log("i am rendering dashboard level 2");
            return (
                <Page.Content title="Body Overview">
                    <Grid.Row>
                        <Grid.Col md={6} lg={12}>
                            <Grid.Row>
                                <Grid.Col sm={6} lg={3}>
                                    <StatsCard
                                        layout={2}
                                        movement={5}
                                        total="8"
                                        label="Back Pain"
                                        chart={
                                            <C3Chart
                                                style={{height: "100%"}}
                                                padding={{
                                                    bottom: -10,
                                                    left: -1,
                                                    right: -1,
                                                }}
                                                data={{
                                                    names: {
                                                        data1: "Pain Index",
                                                    },
                                                    columns: [["data1", 30, 40, 10, 40, 12, 22, 40]],
                                                    type: "area",
                                                }}
                                                legend={{
                                                    show: false,
                                                }}
                                                transition={{
                                                    duration: 0,
                                                }}
                                                point={{
                                                    show: false,
                                                }}
                                                tooltip={{
                                                    format: {
                                                        title: function (x) {
                                                            return "";
                                                        },
                                                    },
                                                }}
                                                axis={{
                                                    y: {
                                                        padding: {
                                                            bottom: 0,
                                                        },
                                                        show: false,
                                                        tick: {
                                                            outer: false,
                                                        },
                                                    },
                                                    x: {
                                                        padding: {
                                                            left: 0,
                                                            right: 0,
                                                        },
                                                        show: false,
                                                    },
                                                }}
                                                color={{
                                                    pattern: ["#467fcf"],
                                                }}
                                            />
                                        }
                                    />
                                </Grid.Col>
                                <Grid.Col sm={6} lg={3}>
                                    <StatsCard
                                        layout={2}
                                        movement={-3}
                                        total="Stable"
                                        label="Diarrhea"
                                        chart={
                                            <C3Chart
                                                style={{height: "100%"}}
                                                padding={{
                                                    bottom: -10,
                                                    left: -1,
                                                    right: -1,
                                                }}
                                                data={{
                                                    names: {
                                                        data1: "Diarrhea",
                                                    },
                                                    columns: [["data1", 30, 40, 10, 40, 12, 22, 40]],
                                                    type: "area",
                                                }}
                                                legend={{
                                                    show: false,
                                                }}
                                                transition={{
                                                    duration: 0,
                                                }}
                                                point={{
                                                    show: false,
                                                }}
                                                tooltip={{
                                                    format: {
                                                        title: function (x) {
                                                            return "";
                                                        },
                                                    },
                                                }}
                                                axis={{
                                                    y: {
                                                        padding: {
                                                            bottom: 0,
                                                        },
                                                        show: false,
                                                        tick: {
                                                            outer: false,
                                                        },
                                                    },
                                                    x: {
                                                        padding: {
                                                            left: 0,
                                                            right: 0,
                                                        },
                                                        show: false,
                                                    },
                                                }}
                                                color={{
                                                    pattern: ["#e74c3c"],
                                                }}
                                            />
                                        }
                                    />
                                </Grid.Col>
                                <Grid.Col sm={6} lg={3}>
                                    <StatsCard
                                        layout={2}
                                        movement={-3}
                                        total="Normal"
                                        label="Appetite"
                                        chart={
                                            <C3Chart
                                                style={{height: "100%"}}
                                                padding={{
                                                    bottom: -10,
                                                    left: -1,
                                                    right: -1,
                                                }}
                                                data={{
                                                    names: {
                                                        data1: "Appetite",
                                                    },
                                                    columns: [["data1", 30, 40, 10, 40, 12, 22, 40]],
                                                    type: "area",
                                                }}
                                                legend={{
                                                    show: false,
                                                }}
                                                transition={{
                                                    duration: 0,
                                                }}
                                                point={{
                                                    show: false,
                                                }}
                                                tooltip={{
                                                    format: {
                                                        title: function (x) {
                                                            return "";
                                                        },
                                                    },
                                                }}
                                                axis={{
                                                    y: {
                                                        padding: {
                                                            bottom: 0,
                                                        },
                                                        show: false,
                                                        tick: {
                                                            outer: false,
                                                        },
                                                    },
                                                    x: {
                                                        padding: {
                                                            left: 0,
                                                            right: 0,
                                                        },
                                                        show: false,
                                                    },
                                                }}
                                                color={{
                                                    pattern: ["#5eba00"],
                                                }}
                                            />
                                        }
                                    />
                                </Grid.Col>
                                <Grid.Col sm={6} lg={3}>
                                    <StatsCard
                                        layout={2}
                                        movement={9}
                                        total="7"
                                        label="Fatigue"
                                        chart={
                                            <C3Chart
                                                style={{height: "100%"}}
                                                padding={{
                                                    bottom: -10,
                                                    left: -1,
                                                    right: -1,
                                                }}
                                                data={{
                                                    names: {
                                                        data1: "Fatigue",
                                                    },
                                                    columns: [["data1", 30, 40, 10, 40, 12, 22, 40]],
                                                    type: "area",
                                                }}
                                                legend={{
                                                    show: false,
                                                }}
                                                transition={{
                                                    duration: 0,
                                                }}
                                                point={{
                                                    show: false,
                                                }}
                                                tooltip={{
                                                    format: {
                                                        title: function (x) {
                                                            return "";
                                                        },
                                                    },
                                                }}
                                                axis={{
                                                    y: {
                                                        padding: {
                                                            bottom: 0,
                                                        },
                                                        show: false,
                                                        tick: {
                                                            outer: false,
                                                        },
                                                    },
                                                    x: {
                                                        padding: {
                                                            left: 0,
                                                            right: 0,
                                                        },
                                                        show: false,
                                                    },
                                                }}
                                                color={{
                                                    pattern: ["#f1c40f"],
                                                }}
                                            />
                                        }
                                    />
                                </Grid.Col>
                            </Grid.Row>
                        </Grid.Col>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Col md={6} lg={12}>
                            <Card>
                                <Card.Header>
                                    <Card.Title>Overall Health</Card.Title>
                                </Card.Header>
                                <C3Chart
                                    style={{height: "10rem"}}
                                    data={{
                                        columns: [
                                            // each columns data
                                            [
                                                "data1",
                                                10,
                                                15,
                                                11,
                                                12,
                                                17,
                                                15,
                                                16,
                                                18,
                                                36,
                                                17,
                                                22,
                                                15,
                                                16,
                                                13,
                                                12,
                                                12,
                                                16,
                                                50,
                                                30,
                                                20,
                                                25,
                                                24,
                                                57,
                                                75,
                                                72,
                                            ],
                                        ],
                                        type: "area", // default type of chart
                                        groups: [["data1", "data2", "data3"]],
                                        colors: {
                                            data1: colors["blue"],
                                        },
                                        names: {
                                            // name of each serie
                                            data1: "Body Index (1-100)",
                                        },
                                    }}
                                    axis={{
                                        y: {
                                            padding: {
                                                bottom: 0,
                                            },
                                            show: false,
                                            tick: {
                                                outer: false,
                                            },
                                        },
                                        x: {
                                            padding: {
                                                left: 0,
                                                right: 0,
                                            },
                                            show: true,
                                        },
                                    }}
                                    legend={{
                                        position: "inset",
                                        padding: 0,
                                        inset: {
                                            anchor: "top-left",
                                            x: 20,
                                            y: 8,
                                            step: 10,
                                        },
                                    }}
                                    tooltip={{
                                        format: {
                                            title: function (x) {
                                                return "";
                                            },
                                        },
                                    }}
                                    padding={{
                                        bottom: 0,
                                        left: -1,
                                        right: -1,
                                    }}
                                    point={{
                                        show: false,
                                    }}
                                />
                                <Table
                                    cards={true}
                                    striped={true}
                                    responsive={true}
                                    className="table-vcenter"
                                >
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.ColHeader colSpan={2}>Reading</Table.ColHeader>
                                            <Table.ColHeader>Description</Table.ColHeader>
                                            <Table.ColHeader>Last observed</Table.ColHeader>
                                            <Table.ColHeader/>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        <Table.Row>
                                            <Table.Col className="w-1">
                                                <Icon prefix="fe" name="cloud-drizzle"/>
                                            </Table.Col>
                                            <Table.Col>Bleeding</Table.Col>
                                            <Table.Col>Gum, sustained, 2 hours</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 11, 2018</Table.Col>
                                            <Table.Col className="w-1">
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="alert-triangle"/>
                                            </Table.Col>
                                            <Table.Col>Bruise</Table.Col>
                                            <Table.Col>Knee, True/False, fell off the chair</Table.Col>
                                            <Table.Col className="text-nowrap">
                                                Dec 13, 2018
                                            </Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="fast-forward"/>
                                            </Table.Col>
                                            <Table.Col>Exercise</Table.Col>
                                            <Table.Col>35 minutes of walking, strenuous levels</Table.Col>
                                            <Table.Col className="text-nowrap">
                                                Dec 9, 2018
                                            </Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="git-merge"/>
                                            </Table.Col>
                                            <Table.Col>Exercise</Table.Col>
                                            <Table.Col>Yoga, 30 minutes, Iyengar yoga, 10 minutes of cool
                                                down</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 12, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="eye"/>
                                            </Table.Col>
                                            <Table.Col>Eyes</Table.Col>
                                            <Table.Col>Watery, off/on for whole day, redness developed</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 12, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="bar-chart-2"/>
                                            </Table.Col>
                                            <Table.Col>Fingers</Table.Col>
                                            <Table.Col>Numbness developed in the index finger of the right
                                                hand</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 9, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="layers"/>
                                            </Table.Col>
                                            <Table.Col>Food</Table.Col>
                                            <Table.Col>3 slices of bread for breakfast</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 21, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="grid"/>
                                            </Table.Col>
                                            <Table.Col>Food</Table.Col>
                                            <Table.Col>Rice with lentil soup for lunch</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 16, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="filter"/>
                                            </Table.Col>
                                            <Table.Col>Food</Table.Col>
                                            <Table.Col>5 glasses of water throughout the day</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 17, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="activity"/>
                                            </Table.Col>
                                            <Table.Col>Heart</Table.Col>
                                            <Table.Col>121 over 89, with normal exercise levels</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 9, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="thumbs-down"/>
                                            </Table.Col>
                                            <Table.Col>Medicine</Table.Col>
                                            <Table.Col>Nausea suppressing medicine, 2 pills taken 3 times a day</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 9, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="thumbs-down"/>
                                            </Table.Col>
                                            <Table.Col>Mouth</Table.Col>
                                            <Table.Col>Sore throat developed in the evening</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 10, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="thumbs-down"/>
                                            </Table.Col>
                                            <Table.Col>Nose</Table.Col>
                                            <Table.Col>Stuffy throughout the day, some relief in the night</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 12, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="alert-circle"/>
                                            </Table.Col>
                                            <Table.Col>Pain</Table.Col>
                                            <Table.Col>Pain developed in the back of the neck during the day</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 20, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="target"/>
                                            </Table.Col>
                                            <Table.Col>Rash</Table.Col>
                                            <Table.Col>Constant and increasing itching near the port mount</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 21, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="thumbs-up"/>
                                            </Table.Col>
                                            <Table.Col>Sleep</Table.Col>
                                            <Table.Col>Slept well, possible 3+ hours of REM</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 9, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="thumbs-down"/>
                                            </Table.Col>
                                            <Table.Col>Stomach</Table.Col>
                                            <Table.Col>Appetite is not consistent for last four days</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 7, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="sunrise"/>
                                            </Table.Col>
                                            <Table.Col>Stool</Table.Col>
                                            <Table.Col>Felt constipated throughout the day</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 10, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="loader"/>
                                            </Table.Col>
                                            <Table.Col>Swelling</Table.Col>
                                            <Table.Col>Feet swell up in the morning for last 2 days</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 18, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="thermometer"/>
                                            </Table.Col>
                                            <Table.Col>Temperature</Table.Col>
                                            <Table.Col>96.6 at 10am</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 19, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Col>
                                                <Icon prefix="fe" name="anchor"/>
                                            </Table.Col>
                                            <Table.Col>Weight</Table.Col>
                                            <Table.Col>133 Lbs, taken right after breakfast</Table.Col>
                                            <Table.Col className="text-nowrap">Dec 24, 2018</Table.Col>
                                            <Table.Col>
                                            </Table.Col>
                                        </Table.Row>
                                    </Table.Body>
                                </Table>
                            </Card>
                        </Grid.Col>
                    </Grid.Row>
                </Page.Content>
            );
            /*
                return [{}].concat(bodysigns).map(
                    (bodysign, i) =>
                        i !== 0
                            ? <LinkContainer key={bodysign.noteId} to={`/notebook/${bodysign.noteId}`}>
                                <ListGroupItem header={bodysign.content.trim().split("\n")[0]}>
                                    {"Created: " + new Date(bodysign.createdAt).toLocaleString()}
                                </ListGroupItem>
                            </LinkContainer>
                            : <LinkContainer key="new" to="/notebook/new">
                                <ListGroupItem>
                                    <h4>
                                        <b>{"\uFF0B"}</b> Create a new entry in the notebook
                                    </h4>
                                </ListGroupItem>
                            </LinkContainer>
                );

            */
        } else {
            console.log("i am rendering bodysigns level 2");

            return [{}].concat(bodysigns).map(
                (bodysign, i) =>
                    i !== 0
                        ? <Table.Row>
                            <Table.Col>
                                <LinkContainer key={bodysign.noteId} to={`/notebook/${bodysign.noteId}`}>
                                <Icon prefix="fe" name={bodysign.content.trim().split(":")[2]}/>
                                </LinkContainer>
                            </Table.Col>
                            <Table.Col>{bodysign.content.trim().split(":")[0] + ", " + bodysign.content.trim().split(":")[1]}</Table.Col>
                            <Table.Col>{bodysign.content.trim().split(":")[3] + ", " + bodysign.content.trim().split(":")[4]}</Table.Col>
                            <Table.Col className="text-nowrap">{new Date(bodysign.createdAt).toLocaleString()}</Table.Col>
                            <Table.Col>
                            </Table.Col>
                        </Table.Row>
                        : <Table.Header>
                            <Table.Row>
                                <Table.ColHeader colSpan={2}>Reading</Table.ColHeader>
                                <Table.ColHeader>Description</Table.ColHeader>
                                <Table.ColHeader>Observed</Table.ColHeader>
                                <Table.ColHeader/>
                            </Table.Row>
                        </Table.Header>

            );
        }
    }

    renderBodysigns2() {
        console.log(this.state.demoUser);
        if (!!this.state.demoUser) {
            console.log("i am rendering dashboard level 1");
            return (
                <ListGroup>
                    {!this.state.isLoading && this.renderBodysignsList2(this.state.bodysigns)}
                </ListGroup>
            );
        } else {
            console.log("i am rendering bodysigns level 1");
            return (
                <Page.Content title="Body Overview">
                    <Grid.Row>
                        <Grid.Col md={6} lg={12}>
                            <Card>
                                <Card.Header>
                                    <Card.Title>Your Recorded Readings</Card.Title>
                                </Card.Header>
                                <Table
                                    cards={true}
                                    striped={true}
                                    responsive={true}
                                    className="table-vcenter"
                                >
                                    {!this.state.isLoading && this.renderBodysignsList2(this.state.bodysigns)}
                                </Table>
                            </Card>
                        </Grid.Col>
                    </Grid.Row>
                    <Grid.Row>&nbsp;</Grid.Row>
                    <Grid.Row>
                        <Grid.Col>
                        <LinkContainer key="new" to="/notebook/new">
                            <ListGroupItem>
                                <b>{"\uFF0B"}</b> Record a new entry in the notebook
                            </ListGroupItem>
                        </LinkContainer>                            
                        </Grid.Col>
                    </Grid.Row>
                </Page.Content>
            );
        }
    }

    render() {
        return (
            <div className="Home">
                {this.props.isAuthenticated ? this.renderBodysigns2() : this.renderLander()}
            </div>
        );
    }
}